<div class="fab-actions" [class.is-fullscreen]="isFullscreen">
    <layout-fab-sub-tools
        *ngIf="showLeadsAnnotationsButton"
        [estensaIcon]="'icon_misure'"
        tooltip="{{ 'MEASURES' | translate }}"
    >
        <mat-button-toggle-group
            class="se-sub-options"
            [(ngModel)]="selectedMeasures"
            multiple
            (click)="onSelectedMeasures()"
        >
            <mat-button-toggle value="global" mat-button>{{ 'GLOBAL_ANNOTATIONS' | translate }}</mat-button-toggle>
            <mat-button-toggle value="lead" mat-button>{{ 'LEADS_ANNOTATIONS' | translate }}</mat-button-toggle>
        </mat-button-toggle-group>
    </layout-fab-sub-tools>

    <div class="fab-content" *ngIf="!isShowingLeads">
        <button
            class="fab-expander"
            (click)="isFabOpen = !isFabOpen"
            mat-mini-fab
            matTooltip="{{ 'Tools' | translate }}"
            matTooltipClass="mat-tooltip-bigger"
            matTooltipShowDelay="500"
            matTooltipPosition="left"
        >
            <mat-icon *ngIf="!isFabOpen">more_vert</mat-icon>
            <mat-icon *ngIf="isFabOpen">close</mat-icon>
        </button>
    </div>
    <div class="fab-tools" *ngIf="isFabOpen && !isShowingLeads">
        <layout-fab-sub-tools
            (actionClick)="onFullscreenChange()"
            tooltip="{{ 'FullScreen' | translate }}"
            [smallFontEnabled]="true"
            [estensaIcon]="isFullscreen ? 'icon_fit_to_screen' : 'icon_full_screen'"
        >
        </layout-fab-sub-tools>
        <layout-fab-sub-tools
            (actionClick)="onSelectedArrangement()"
            tooltip="{{ 'ARRANGEMENT' | translate }}"
            [estensaIcon]="'icon_disposizione'"
        >
            <mat-button-toggle-group class="se-sub-options" [(ngModel)]="selectedArrangementValue">
                <mat-button-toggle *ngFor="let arrangement of arrangements" [value]="arrangement.value" mat-button>
                    {{ arrangement.key }}
                </mat-button-toggle>
            </mat-button-toggle-group>
        </layout-fab-sub-tools>
        <layout-fab-sub-tools
            (actionClick)="onSelectedFormat()"
            [estensaIcon]="'icon_formato'"
            tooltip="{{ 'FORMAT' | translate }}"
        >
            <mat-button-toggle-group class="se-sub-options" [(ngModel)]="selectedFormat">
                <mat-button-toggle [value]="0" mat-button>{{ 'Standard' | translate }}</mat-button-toggle>
                <mat-button-toggle [value]="1" mat-button>{{ 'Cabrera' | translate }}</mat-button-toggle>
            </mat-button-toggle-group>
        </layout-fab-sub-tools>
        <layout-fab-sub-tools
            (actionClick)="onSelectedTimeAlignment()"
            [actionIcon]="'icon_allineamento_temporale'"
            tooltip="{{ 'TEMPORAL_ALIGN' | translate }}"
        >
            <mat-button-toggle-group class="se-sub-options" [(ngModel)]="selectedTimeAlignment">
                <mat-button-toggle [value]="0" mat-button>{{ 'SEQUENTIAL' | translate }}</mat-button-toggle>
                <mat-button-toggle [value]="1" mat-button>{{ 'SIMULTANEOUS' | translate }}</mat-button-toggle>
            </mat-button-toggle-group>
        </layout-fab-sub-tools>
        <layout-fab-sub-tools
            (actionClick)="onSelectedPaperRate()"
            [estensaIcon]="'icon_velocita_carta_millimetrata'"
            tooltip="{{ 'PAPER_RATE' | translate }}"
        >
            <mat-button-toggle-group class="se-sub-options" [(ngModel)]="selectedPaperRate">
                <mat-button-toggle [value]="0" mat-button>{{ '25mm' | translate }}</mat-button-toggle>
                <mat-button-toggle [value]="1" mat-button>{{ '50mm' | translate }}</mat-button-toggle>
            </mat-button-toggle-group>
        </layout-fab-sub-tools>
        <layout-fab-sub-tools tooltip="{{ 'PAPER_OPACITY' | translate }}" [estensaIcon]="'icon_opacita_carta'">
            <se-fab-slider min="0" max="1" step="0.1" labelFactor="10" [(ngModel)]="paperOpacity"></se-fab-slider>
        </layout-fab-sub-tools>
        <layout-fab-sub-tools tooltip="{{ 'TRACE_SPACING' | translate }}" [estensaIcon]="'icon_spaziatura_tracce'">
            <se-fab-slider
                min="0"
                max="0.3"
                step="0.01"
                labelFactor="100"
                [(ngModel)]="traceSpacing"
                increaseIcon="keyboard_arrow_up"
                decreaseIcon="keyboard_arrow_down"
            ></se-fab-slider>
        </layout-fab-sub-tools>
        <layout-fab-sub-tools
            tooltip="{{ 'STUDIES_SPACING' | translate }}"
            [estensaIcon]="'icon_icon_distanza_tracce'"
            *ngIf="visualComparison"
        >
            <se-fab-slider
                min="-1"
                max="2"
                step="0.01"
                labelFactor="100"
                [(ngModel)]="studySpacing"
                increaseIcon="keyboard_arrow_up"
                decreaseIcon="keyboard_arrow_down"
            ></se-fab-slider>
        </layout-fab-sub-tools>

        <layout-fab-sub-tools
            tooltip="{{ 'HORIZONTAL_STUDIES_SPACING' | translate }}"
            [actionIcon]="'icon_distanza_tracce_orizzontale'"
            *ngIf="isHorizontalSpacingEnabled()"
        >
            <se-fab-slider
                min="-1"
                max="2.75"
                step="0.01"
                labelFactor="100"
                [(ngModel)]="horizontalStudySpacing"
                increaseIcon="keyboard_arrow_up"
                decreaseIcon="keyboard_arrow_down"
            ></se-fab-slider>
        </layout-fab-sub-tools>
        <layout-fab-sub-tools
            *ngIf="visualComparison"
            (actionClick)="onSelectedGuidedComparison()"
            [estensaIcon]="'icon_VC_guidata'"
            tooltip="{{ 'ECG_guidedVC' | translate }}"
        >
            <mat-button-toggle-group class="se-sub-options" [(ngModel)]="selectedGuidedComparisonValue">
                <mat-button-toggle
                    *ngFor="let guidedComparison of guidedComparisons"
                    [value]="guidedComparison.value"
                    mat-button
                >
                    {{ guidedComparison.key }}
                </mat-button-toggle>
            </mat-button-toggle-group>
        </layout-fab-sub-tools>
        <layout-fab-sub-tools
            [estensaIcon]="'icon_ruler'"
            (actionClick)="onCaliperMode()"
            tooltip="{{ 'CALIPER' | translate }}"
        >
            <mat-button-toggle-group class="se-sub-options" [(ngModel)]="caliperMode">
                <mat-button-toggle [value]="0" mat-button>{{ 'SINGLE_CALIPER' | translate }}</mat-button-toggle>
                <mat-button-toggle [value]="1" mat-button>{{ 'MULTI_CALIPER' | translate }}</mat-button-toggle>
            </mat-button-toggle-group>
        </layout-fab-sub-tools>
        <layout-fab-sub-tools
            [actionIcon]="'icon_punti_fiduciali'"
            (actionClick)="onFiducialPoints()"
            tooltip="{{ 'FIDUCIAL_POINTS' | translate }}"
        >
            <mat-button-toggle-group class="se-sub-options" [(ngModel)]="fiducialPointsVisible">
                <mat-button-toggle [value]="true" mat-button
                    >{{ 'SHOW_FIDUCIAL_POINTS' | translate }}
                </mat-button-toggle>
                <mat-button-toggle [value]="false" mat-button
                    >{{ 'HIDE_FIDUCIAL_POINTS' | translate }}
                </mat-button-toggle>
            </mat-button-toggle-group>
        </layout-fab-sub-tools>
        <layout-fab-sub-tools
            tooltip="{{ 'FIT' | translate }}"
            (actionClick)="onFit()"
            [enableEstensaFontSet]="false"
            [estensaIcon]="'settings_overscan'"
        ></layout-fab-sub-tools>
        <layout-fab-sub-tools
            tooltip="{{ 'ZOOM' | translate }}"
            [enableEstensaFontSet]="false"
            [estensaIcon]="'zoom_in'"
        >
            <se-fab-slider min="1" max="10" step="0.09" [(ngModel)]="zoomFactor"></se-fab-slider>
        </layout-fab-sub-tools>
        <layout-fab-sub-tools
            *ngIf="customCommandState.visible"
            [matTooltip]="customCommandState.text"
            (actionClick)="onCustomCommand()"
            [enableEstensaFontSet]="false"
            [estensaIcon]="'print'"
        >
        </layout-fab-sub-tools>
        <layout-fab-sub-tools
            *ngIf="enableSchillerFilters"
            (actionClick)="onLowFilterChange()"
            [estensaIcon]="'icon_filtro_rumore_1'"
            tooltip="{{ 'LowFilter' | translate }}"
        >
            <mat-button-toggle-group
                class="se-sub-options"
                [(ngModel)]="lowFilter"
                (change)="onLowFilterChange($event.value)"
            >
                <mat-button-toggle
                    *ngFor="let filter of schillerFiltersConfiguration.lowFilters"
                    [value]="filter"
                    mat-button
                >
                    <ng-container *ngIf="!filter">{{ 'NoFilter' | translate }}</ng-container>
                    <ng-container *ngIf="filter">{{ filter }} Hz</ng-container>
                </mat-button-toggle>
            </mat-button-toggle-group>
        </layout-fab-sub-tools>
        <layout-fab-sub-tools
            *ngIf="enabledPrintAsDisplayed"
            (actionClick)="onPrintAsDisplayed()"
            [estensaIcon]="'picture_as_pdf'"
            [enableEstensaFontSet]="false"
            tooltip="{{ 'PrintSettings' | translate }}"
        >
            <mat-button-toggle-group class="se-sub-options" [(ngModel)]="printAsDisplayed">
                <mat-button-toggle [value]="false" mat-button>{{ 'Standard' | translate }}</mat-button-toggle>
                <mat-button-toggle [value]="true" mat-button>{{ 'PrintAsDisplayed' | translate }}</mat-button-toggle>
            </mat-button-toggle-group>
        </layout-fab-sub-tools>
    </div>
</div>
